import { render, staticRenderFns } from "./HomeServiceTypeServiceElderNumber.vue?vue&type=template&id=6eb1e414&scoped=true&"
import script from "./HomeServiceTypeServiceElderNumber.vue?vue&type=script&lang=js&"
export * from "./HomeServiceTypeServiceElderNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb1e414",
  null
  
)

export default component.exports